<script setup lang="ts">
import ContentHeader from '@/components/ui/ContentHeader.vue'
import ContentBody from '@/components/ui/ContentBody.vue'
import Card from '@/components/Card/Card.vue'
import { FireRiskDashboardViewModel } from './viewmodels/FireRiskDashboard.viewmodel'
import { FireOutbreakRepositoryApiAdapter } from '@/@core/fire-risk-dashboard/infra/fire-outbreak-repository-adapter/FireOutbreakRepositoryApi.adapter'
import { computed, onMounted, onUnmounted, provide, watch } from 'vue'
import FireRiskByFarmView from './components/views/FireRiskByFarm.view.vue'
import { useWebSocket, useOnline } from '@vueuse/core'
import { NetworkConnectionStatusEnum } from './enums/NetworkConnectionStatus.enum'
import FireAlertMapView from './components/views/FireAlertMap.view.vue'
import FireRiskDashboardHeaderView from './components/views/FireRiskDashboardHeader.view.vue'
import FireAlertsTableView from './components/views/FireAlertsTable.view.vue'
import { fireRiskApi } from '@/services/clients/AxiosClients'
import { MonitoredAreaRepositoryApiAdapter } from '@/@core/monitored-area/infra/monitored-area-repository-adapter/MonitoredAreaRepositoryApi.adapter'
import { RecentFireRiskRepositoryApiAdapter } from '@/@core/fire-risk-dashboard/infra/recent-fire-risk-repository-adapter/RecentFireRiskRepositoryApi.adapter'
import { breakpointsTailwind, useBreakpoints } from '@vueuse/core'

const monitoredAreaRepository = new MonitoredAreaRepositoryApiAdapter(fireRiskApi)
const recentFireRiskRepository = new RecentFireRiskRepositoryApiAdapter(fireRiskApi)
const fireOutbreakRepository = new FireOutbreakRepositoryApiAdapter(fireRiskApi)

const vm = new FireRiskDashboardViewModel(
	monitoredAreaRepository,
	fireOutbreakRepository,
	recentFireRiskRepository,
)
provide('fire-risk-dashboard-viewmodel', vm)

if (!vm.selectedFarmsIds.value) window.location.reload()

const customerId = localStorage.getItem('customerId')
const token = localStorage.getItem('jwt')

const { status, data, close } = useWebSocket(`${process.env.VUE_APP_WEBSOCKET_API}/${customerId}`, {
	protocols: [token?.split(' ').at(1) ?? ''],
})

const webSocketConnectionStatus = computed(() =>
	useOnline().value
		? (status.value as NetworkConnectionStatusEnum)
		: NetworkConnectionStatusEnum.CLOSED,
)
watch(data, (message: string) => vm.recieveFireOutbreakAlert(message))

const breakpoints = useBreakpoints(breakpointsTailwind)

const isWide = computed(() => breakpoints.active().value === '2xl')

onMounted(() => vm.loadMonitoredFarms())

onUnmounted(() => close())
</script>

<template>
	<div>
		<content-header :wide="isWide">
			<fire-risk-dashboard-header-view :websocket-status="webSocketConnectionStatus" />
		</content-header>
		<content-body :wide="isWide">
			<card v-show="vm.showChartSection.value">
				<fire-risk-by-farm-view />
			</card>
			<card v-show="vm.showMapSection.value">
				<fire-alert-map-view />
			</card>
			<card v-show="vm.showTableSection.value">
				<fire-alerts-table-view />
			</card>
		</content-body>
	</div>
</template>

<style scoped>
.container__card {
	width: 100%;
}
</style>
